// Web implementation of the link component.

import { useDatastore } from 'util/datastore';
import { logEventAsync } from 'util/eventlog';
import { requestAppNavigateToExternalUrl } from 'util/webview';

import { getIsInPsiNativeAppWebview } from './url';

export type WebLinkBaseProps = {
    url: string;
    newTab: boolean;
    style: Record<string, any>;
    setHover?: (h: boolean) => void;
    children: React.ReactNode;
    onLinkPress: () => void;
    linkType?: string;
};

export function WebLinkBase({ url, newTab, style, setHover = (h: boolean) => {}, children, onLinkPress, linkType }: WebLinkBaseProps) {
    const datastore = useDatastore();
    const onClick = () => {
        if (linkType) {
            logEventAsync(datastore, 'link-click', { linkType, url });
        }

        if (onLinkPress) {
            onLinkPress();
        }

        if (getIsInPsiNativeAppWebview()) {
            requestAppNavigateToExternalUrl(url);
        }
    };

    const target = newTab ? '_blank' : '_parent';
    return (
        <a
            href={url}
            onClick={onClick}
            onMouseEnter={() => setHover(true)}
            onMouseLeave={() => setHover(false)}
            rel='noreferrer'
            style={style}
            target={target}
        >
            {children}
        </a>
    );
}
